<div class="requests-container">
    <div class="loading" *ngIf="loading">
        <div class="spinner"></div>
        <p>Loading requests...</p>
    </div>

    <div class="notification-section" *ngIf="error">
        <div class="notification-message">{{ error }}</div>
    </div>

    <!-- Requests Table Card -->
    <div class="requests-table-card">
        <div class="table-wrapper">
            <table class="requests-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="requests.length === 0">
                        <td colspan="4" class="no-data">
                            <div class="no-data-content">
                                <span class="no-data-icon">📋</span>
                                <p>No requests to show</p>
                                <p class="no-data-hint">Requests will appear here when available</p>
                            </div>
                        </td>
                    </tr>
                    <tr *ngFor="let request of paginatedRequests">
                        <td class="request-name">{{ request.name }}</td>
                        <td>{{ request.date }}</td>
                        <td>
                            <span class="status-badge" [ngClass]="request.statusClass">
                                {{ request.status }}
                            </span>
                        </td>
                        <td>
                            <button class="action-btn">{{ request.action }}</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination Controls -->
        <div class="pagination-container" *ngIf="requests.length > 0">
            <div class="pagination-left">
                <span class="rows-label">Rows per page:</span>
                <div class="page-size-wrapper">
                    <select class="page-size-select" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
                        <option [value]="10">10</option>
                        <option [value]="20">20</option>
                        <option [value]="50">50</option>
                        <option [value]="100">100</option>
                    </select>
                    <span class="dropdown-icon material-icons">expand_more</span>
                </div>
            </div>

            <div class="pagination-center">
                <span class="page-info">{{ (currentPage - 1) * pageSize + 1 }}–{{ Math.min(currentPage * pageSize, requests.length) }} of {{ requests.length }}</span>
            </div>

            <div class="pagination-right">
                <button class="nav-btn" [disabled]="currentPage === 1" (click)="goToPage(1)" title="First page">
                    <span class="icon">«</span>
                </button>
                <button class="nav-btn" [disabled]="currentPage === 1" (click)="prevPage()" title="Previous page">
                    <span class="icon">‹</span>
                </button>
                <button class="nav-btn" [disabled]="currentPage === totalPages" (click)="nextPage()" title="Next page">
                    <span class="icon">›</span>
                </button>
                <button class="nav-btn" [disabled]="currentPage === totalPages" (click)="goToPage(totalPages)" title="Last page">
                    <span class="icon">»</span>
                </button>
            </div>
        </div>
    </div>
</div>
